import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Terminal.svg?component
var Terminal_exports = /* @__PURE__ */ __exportAll({
	default: () => Terminal_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		fill: "none",
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M13 15h5M6 9l4 3-4 3"
	}, null, -1), createElementVNode("path", {
		fill: "none",
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M21 2.8H3.1c-.7 0-1.4.6-1.4 1.4v15.6c0 .7.6 1.4 1.4 1.4H21c.7 0 1.4-.6 1.4-1.4V4.2c0-.8-.5-1.4-1.3-1.4z"
	}, null, -1)])]);
}
var Terminal_default = { render: render$1 };
//#endregion
export { Terminal_exports, Terminal_default as default, render$1 as render };

//# sourceMappingURL=Terminal.svg_component.js.map